import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { smevCheckAllApplicationFailed, smevCheckAllApplicationSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { NO_CONTENT } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* smevCheckAllApplication(action) {
  try {
    const id = action.payload;
    const url = `${BACKEND_URL}/resources/applications/${id}/run-all-checks`;
    const dataResponse = yield makeRequest(url, {}, action, 'POST', true);
    if (dataResponse.status === NO_CONTENT) {
      yield put(smevCheckAllApplicationSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(smevCheckAllApplicationFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(smevCheckAllApplicationFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
